import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';

async function setupTotpByQrCode(apiClient: ApiClient, accountId: number, file: File) {
  const formData = new FormData();
  formData.append('qr_code', file);

  return apiClient.POST('/op/v2/account/{id}/setup-totp-by-qr-code', {
    params: { path: { id: accountId } },
    // @ts-expect-error Body is not documented as FormData in the OpenAPI spec
    body: formData,
    headers: {
      Accept: 'application/json',
      'Content-Type': null,
    },
  });
}

export default function useSetupTotpByQrCodeMutation(accountId: number) {
  const apiClient = useApiClient();

  return useMutation<InferFetchData<typeof setupTotpByQrCode>, ApiError, File>({
    mutationKey: ['SetupTotpByQrCode', accountId],
    mutationFn: (file) => throwOnError(setupTotpByQrCode(apiClient, accountId, file)),
  });
}
